import { render } from "./LoadSpinner.vue?vue&type=template&id=9ccebdfa&scoped=true"
import script from "./LoadSpinner.vue?vue&type=script&lang=js"
export * from "./LoadSpinner.vue?vue&type=script&lang=js"

import "./LoadSpinner.vue?vue&type=style&index=0&id=9ccebdfa&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ccebdfa"]])

export default __exports__